import type { ImportQueueItem } from '../types/import-queue-item';
import type { ImportQueueProgress } from '../types/import-queue-progress';

export function summarizeImportQueueItems(
  items: ImportQueueItem[]
): ImportQueueProgress {
  const progress: ImportQueueProgress = {
    total: items.length,
    uploading: 0,
    processing: 0,
    done: 0,
    failed: 0,
  };
  for (const item of items) {
    switch (item.status) {
      case 'queued':
      case 'preparing':
      case 'uploading':
        progress.uploading += 1;
        break;
      case 'processing':
        progress.processing += 1;
        break;
      case 'done':
        progress.done += 1;
        break;
      case 'failed':
        progress.failed += 1;
        break;
    }
  }
  return progress;
}
